import React, { useEffect, useState } from 'react';
import { Layer, Stage, Image, Line, Circle } from 'react-konva';
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import { useIntl } from 'react-intl';
import { useCalibrationDotsPosition, useSelectedImage, steps } from '../helper';
import { useField } from 'formik';
import { CONTAINER_HEIGHT, CONTAINER_WIDTH, Coordinates } from '../models';
import { useBem } from '../../Bem';

export const Step7 = () => {
  const bem = useBem('step7');
  const intl = useIntl();
  const { calibrationDotsPosition } = useCalibrationDotsPosition();
  const image = useSelectedImage();
  const [calpickTopLeftCol, calpickTopLeftColMeta, calpickTopLeftColHelpers] = useField({ name: 'calpickTopLeftCol' });
  const [calpickTopLeftRow, calpickTopLeftRowMeta, calpickTopLeftRowHelpers] = useField({ name: 'calpickTopLeftRow' });
  const [calpickBottomLeftCol, calpickBottomLeftColMeta, calpickBottomLeftColHelpers] = useField({
    name: 'calpickBottomLeftCol',
  });
  const [calpickBottomLeftRow, calpickBottomLeftRowMeta, calpickBottomLeftRowHelpers] = useField({
    name: 'calpickBottomLeftRow',
  });
  const [calpickTopRightColRow, calpickTopRightColMeta, calpickTopRightColHelpers] = useField({
    name: 'calpickTopRightCol',
  });
  const [calpickTopRightRowRow, calpickTopRightRowMeta, calpickTopRightRowHelpers] = useField({
    name: 'calpickTopRightRow',
  });
  const [calpickBottomRightCol, calpickBottomRightColMeta, calpickBottomRightColHelpers] = useField({
    name: 'calpickBottomRightCol',
  });
  const [calpickBottomRightRow, calpickBottomRightRowMeta, calpickBottomRightRowHelpers] = useField({
    name: 'calpickBottomRightRow',
  });
  const [nodeListState, setNodeListState] = useState<Coordinates[]>([]);

  useEffect(() => {
    if (calibrationDotsPosition?.length > 0) {
      const coord1 = getPoint(
        calibrationDotsPosition[0].xPosition,
        calibrationDotsPosition[0].yPosition,
        calibrationDotsPosition[1].xPosition,
        calibrationDotsPosition[1].yPosition,
        0.8,
      );
      const coord2 = getPoint(
        calibrationDotsPosition[2].xPosition,
        calibrationDotsPosition[0].yPosition,
        calibrationDotsPosition[1].xPosition,
        calibrationDotsPosition[1].yPosition,
        0.8,
      );

      setNodeListState([
        { ...calibrationDotsPosition[0] },
        { ...coord1 },
        { ...coord2 },
        { ...calibrationDotsPosition[2] },
      ]);
      calpickTopLeftColHelpers.setValue(coord1.xPosition);
      calpickTopLeftRowHelpers.setValue(coord1.yPosition);

      calpickBottomLeftColHelpers.setValue(calibrationDotsPosition[0].xPosition);
      calpickBottomLeftRowHelpers.setValue(calibrationDotsPosition[0].yPosition);

      calpickTopRightColHelpers.setValue(coord2.xPosition);
      calpickTopRightRowHelpers.setValue(coord2.yPosition);

      calpickBottomRightColHelpers.setValue(calibrationDotsPosition[2].xPosition);
      calpickBottomRightRowHelpers.setValue(calibrationDotsPosition[2].yPosition);
    }
  }, [calibrationDotsPosition?.[0], calibrationDotsPosition?.[1], calibrationDotsPosition?.[2]]);

  const getPoint = (x1: number, y1: number, x2: number, y2: number, c: number) => ({
    xPosition: x1 + (x2 - x1) * c,
    yPosition: y1 + (y2 - y1) * c,
  });

  return (
    <div>
      <p className={bem.elem('title').cls()}>
        <span>(7/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.titleStep_7)}</span>
      </p>
      <div className={bem.elem('canvas_margin').cls()}>
        <Stage className={bem.elem('canvas').cls()} width={CONTAINER_WIDTH} height={CONTAINER_HEIGHT}>
          <Layer>
            <Image image={image} x={0} y={0} />
            {nodeListState.length > 0 && (
              <>
                <Line
                  points={[
                    nodeListState[0].xPosition,
                    nodeListState[0].yPosition,
                    nodeListState[1].xPosition,
                    nodeListState[1].yPosition,
                  ]}
                  stroke="#e74a4a"
                  dash={[15, 10]}
                  strokeWidth={4}
                  lineJoin={'round'}
                  lineCap={'round'}
                />
                <Line
                  points={[
                    nodeListState[2].xPosition,
                    nodeListState[2].yPosition,
                    nodeListState[3].xPosition,
                    nodeListState[3].yPosition,
                  ]}
                  stroke="#e74a4a"
                  dash={[15, 10]}
                  strokeWidth={4}
                  lineJoin={'round'}
                  lineCap={'round'}
                />
              </>
            )}
            {nodeListState.map((node: Coordinates, index: number) => {
              return (
                <Circle key={index} radius={7} fill="#e74a4a" stroke="white" x={node.xPosition} y={node.yPosition} />
              );
            })}
          </Layer>
        </Stage>
      </div>
    </div>
  );
};
